module.exports = __webpack_public_path__ + "img/nexultra-2.134dc46f.jpg";